export default "__VITE_ASSET__QDoayvfx__"